import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartyWiseSalesLedgerViewComponent } from './party-wise-sales-ledger-view/party-wise-sales-ledger-view.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {CoreModule} from "../../core/core.module";
import {Ng2SmartTableModule} from "ng2-smart-table";
import {NgSelectModule} from "@ng-select/ng-select";
import {AddRefreshModule} from "../../shared/add-refresh/add-refresh.module";
import {NgbTabsetModule} from "@ng-bootstrap/ng-bootstrap";
import {SalesOrderModule} from "../sales-order/sales-order.module";

@NgModule({
  declarations: [PartyWiseSalesLedgerViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    Ng2SmartTableModule,
    NgSelectModule,
    AddRefreshModule,
    NgbTabsetModule
  ],
  exports: [
      PartyWiseSalesLedgerViewComponent
  ],
  entryComponents: [
    PartyWiseSalesLedgerViewComponent
  ]
})
export class PartyWiseSalesLedgerModule { }
